import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// @mui material components
import Card from '@mui/material/Card'
import Badge from '@mui/material/Badge'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Footer from 'examples/Footer'
import DataTable from 'examples/Tables/DataTable'
import MDButton from 'components/MDButton'
import MDAlert from 'components/MDAlert'
import { Tooltip, IconButton, Modal } from '@mui/material'

import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'

import CrudService from 'services/cruds-service'
import { AbilityContext } from 'Can'
import { useAbility } from '@casl/react'
import moment from 'moment/moment'
import SubscriptionDevice from 'cruds/device-management/internal-device-management/subscription_device'

function SubscriptionList() {
    let { state } = useLocation()
    const [data, setData] = useState([])
    const [notification, setNotification] = useState({
        value: false,
        text: '',
    })
    const [openModal, setOpenModal] = useState(false)
    const [modalContent, setModalContent] = useState()
    const [subscriptionPlanList, setSubscriptionPlanList] = useState([])
    //   const navigate = useNavigate()

    async function fetchSubscriptionList() {
        try {
            const response = await CrudService.getAllSubscription()
            if (!response.success) {
                setNotification({
                    value: true,
                    text: response.error,
                })
                return
            }
            setData(response.data)
        } catch (error) {
            console.error('fetchSubscriptionList', error)
            setNotification({
                value: true,
                text: err.error,
            })
        }
    }

    useEffect(() => {
        (async () => {
            await fetchSubscriptionList()
        })();
        (async () => {
            try {
                const response = await CrudService.getSubscriptionPlanList();
                setSubscriptionPlanList(response.data);
            } catch (err) {
                console.error(err);
                return null;
            }
        })();
        document.title = `Rivio | Subscription List`
    }, [])

    useEffect(() => {
        if (!state) return
        setNotification({
            value: state.value,
            text: state.text,
        })
    }, [state])

    useEffect(() => {
        if (notification.value === true) {
            let timer = setTimeout(() => {
                setNotification({
                    value: false,
                    text: '',
                })
            }, 5000)
        }
    }, [notification])

    //   const clickAddHandler = () => {
    //     navigate('/subscription-plan/new')
    //   }

    //   const clickEditHandler = (id) => {
    //     navigate(`/subscription-plan/edit/${id}`)
    //   }

    //   const clickDeleteHandler = async (e, id) => {
    //     try {
    //       if (!confirm('Are you sure you want to delete this plan?')) {
    //         e.nativeEvent.stopImmediatePropagation()
    //       } else {
    //         let reseponse = await CrudService.removeSubscriptionPlan(id)
    //         if(!reseponse.success){
    //           setNotification({
    //             value: true,
    //             text: reseponse.error,
    //           })
    //           return
    //         }
    //         // the delete does not send a response
    //         // so I need to get again the categories to set it and this way the table gets updated -> it goes to the useEffect with data dependecy
    //         const response = await CrudService.getSubscriptionPlanList()
    //         setData(response.data)
    //         setNotification({
    //           value: true,
    //           text: 'The Subscription Plan has been successfully deleted',
    //         })
    //       }
    //     } catch (err) {
    //       // it sends error is the Contact is associated with an Contact
    //       console.error(err)
    //       setNotification({
    //         value: true,
    //         text: err.error,
    //       })
    //       return null
    //     }
    //   }

    const openModalHandler = (e, value) => {
        e.preventDefault();
        setModalContent({
            subscription_id: value.subscription_id,
            auto_renew: value.auto_renew,
            cancelled_at: value.cancelled_at,
            end_date: value.end_date,
            plan_id: value.plan_id,
            price_override: value.price_override,
            start_date: value.start_date,
            status_id: value.status_id,
            subscription_source: value.subscription_source
        })
        // setModalContent(value)
        setOpenModal(true);
    }

    const closeModalHandler = () => {
        setOpenModal(false);
    }

    const clickEditHandler = async () => {
        try {
            closeModalHandler();
            await CrudService.updateSubscription(modalContent.subscription_id, modalContent);
            fetchSubscriptionList()
        } catch (error) {
            console.error('clickEditHandler', error)
            setNotification({
                value: true,
                text: err.error,
            })
        }
    }

    const clickDeleteHandler = async (e, id) => {
        try {
            if (!confirm('Are you sure you want to delete this subscription?')) {
                e.nativeEvent.stopImmediatePropagation()
            } else {
                let reseponse = await CrudService.removeSubscription(id)
                if (!reseponse.success) {
                    setNotification({
                        value: true,
                        text: reseponse.error,
                    })
                    return
                }
                fetchSubscriptionList()
                setNotification({
                    value: true,
                    text: 'The Subscription has been successfully removed',
                })
            }
        } catch (err) {
            // it sends error is the Contact is associated with an Contact
            console.error(err)
            setNotification({
                value: true,
                text: err.error,
            })
            return null
        }
    }

    const getRows = (info) => {
        let updatedInfo = info.map((row) => {

            const entityName = row?.Device?.EntityAddressItem?.Entity?.name;
            const firstName = row?.Device?.EntityAddressItem?.Entity?.first_name;
            const lasttName = row?.Device?.EntityAddressItem?.Entity?.last_name;

            return {
                type: 'subscription_plan',
                ...row,
                id: row.subscription_id,
                plan_name: row?.Subscription_Plan?.plan_name,
                device_name: row?.Device?.name ?? '',
                entity_name: row?.Device ? (entityName ? entityName : firstName + ' ' + lasttName) : '',
                item_name: row?.Device?.EntityAddressItem?.name ?? '',
                billing_cycle: row?.Subscription_Plan?.billing_cycle ?? '',
                price_per_device: row?.Subscription_Plan?.price_per_device ?? '',
                created_at: moment(row.created_at).format('MMMM DD, YYYY h:mm:ss A'),
                device_id: row?.Device?.device_id,
            }
        })
        return updatedInfo
    }

    const columns = [
        { Header: 'ID', accessor: 'id' },
        {
            Header: 'Status', accessor: 'status', Cell: (info) => {
                let status_name = info.cell.row.original.StatusType.status_name
                let badgeDetail = info.cell.row.original.status.BadgeDetail
                return (
                    <Badge
                        color={badgeDetail?.color || 'primary'}
                        variant={badgeDetail?.variant}
                        badgeContent={status_name}
                        style={{ marginLeft: '30px' }}
                    ></Badge>
                )
            }
        },
        { Header: 'Plan', accessor: 'plan_name' },
        { Header: 'Device ID', accessor: 'device_id' },
        { Header: 'Device Name', accessor: 'device_name' },
        { Header: 'Entity', accessor: 'entity_name' },
        { Header: 'Item', accessor: 'item_name' },
        { Header: 'Start Date', accessor: 'start_date' },
        { Header: 'End Date', accessor: 'end_date' },
        { Header: 'Source', accessor: 'subscription_source' },
        { Header: 'Billing Cycle', accessor: 'billing_cycle' },
        { Header: 'Price Per Device', accessor: 'price_per_device' },
        { Header: 'Created', accessor: 'created_at' },
        {
            Header: 'actions',
            disableSortBy: true,
            accessor: '',
            Cell: (info) => {
                let showActions = localStorage.getItem('role') === 'Super Admin';
                if(!showActions){
                    return
                }
                return (
                    <MDBox display="flex" alignItems="center" >
                        <Tooltip title="Edit Subscription">
                            <IconButton
                                onClick={(e) => openModalHandler(e, info.row.original)}
                            >
                                <MDTypography>
                                    <EditIcon />
                                </MDTypography>
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Subscription">
                            <IconButton
                                onClick={(e) =>
                                    clickDeleteHandler(e, info.row.values.id)
                                }
                            >
                                <MDTypography>
                                    <DeleteIcon />
                                </MDTypography>
                            </IconButton>
                        </Tooltip>
                    </MDBox >
                )
            },
        },
    ]

    return (
        <DashboardLayout>
            <DashboardNavbar />
            {notification.value && (
                <MDAlert color="info" my="20px">
                    <MDTypography variant="body2" color="white">
                        {notification.text || ''}
                    </MDTypography>
                </MDAlert>
            )}
            <MDBox pt={1}>
                <MDBox>
                    <Card>
                        <MDBox
                            p={3}
                            lineHeight={1}
                            display="flex"
                            justifyContent="space-between"
                        >
                            <MDTypography variant="h5" fontWeight="medium">
                                Subscription List
                            </MDTypography>
                        </MDBox>
                        <DataTable table={{ columns, rows: getRows(data) }} canSearch={true} entriesPerPage={{ defaultValue: 100 }} />
                    </Card>
                </MDBox>
            </MDBox>
            {/* Update Content Modal */}
            <Modal
                open={openModal}
                onClose={closeModalHandler}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Card
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "50%", // Set the desired width here
                        backgroundColor: "white",
                        p: 4,
                    }}
                >
                    <SubscriptionDevice formData={modalContent} setFormData={setModalContent} subscriptionPlanList={subscriptionPlanList} />
                    <MDBox
                        ml="auto"
                        mt={3}
                        display="flex"
                        justifyContent="flex-end"
                    >
                        <MDButton
                            variant="contained"
                            color="secondary"
                            onClick={closeModalHandler}
                        >
                            Cancel
                        </MDButton>
                        <MDButton
                            variant="contained"
                            color="info"
                            style={{ marginLeft: "10px" }}
                            onClick={clickEditHandler}
                        >
                            Save
                        </MDButton>
                    </MDBox>
                </Card>
            </Modal>
            <Footer />
        </DashboardLayout>
    )
}

export default SubscriptionList
